import Axios from "axios";
import * as EndPoints from "./restEndPoints";
import { GetCurrentUser, SignOut } from "../firebase/auth";

// console.log('current user', GetCurrentUser())

Axios.interceptors.request.use(
    async (config) => {
        // Get the current user from Firebase
        const user = GetCurrentUser();

        if (user) {
            // Get the Firebase ID token
            const token = await user.getIdToken();

            // Add the token to the request headers
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Do something with request error
        return Promise.reject(error);
    }
);

Axios.interceptors.response.use(
    (response) => {
        // Do something with response data
        return response;
    },
    (error) => {
        // Check if error is due to 401 Unauthorized
        if (error.response && error.response.status === 401) {
            console.log('Unauthorized request detected, logging out user');
            // Call the logout function
            SignOut().then(() => {
                // Redirect to login page
                window.location.href = '/auth';
            });
        }
        // Do something with response error
        return Promise.reject(error);
    }
);


// * ------------------------------------------------------------------------------ Branch Apis
export const AddNewBranch = (data) => {
    return Axios.post(EndPoints.Post_addBranch, data);
};

export const GetAllBranches = () => {
    return Axios.get(EndPoints.Get_getBranches);
};

export const UpdateBranch = (branchId, data) => {
    return Axios.put(EndPoints.Put_updateBranch(branchId), data);
}

export const GetBranchById = (branchId) => {
    return Axios.get(EndPoints.Get_getBranchById(branchId));
}

export const DeleteBranch = (branchId) => {
    return Axios.delete(EndPoints.Delete_deleteBranch(branchId));
}

// * ------------------------------------------------------------------------------ Buildings Apis
export const AddNewBuilding = (branchId, data) => {
    return Axios.post(EndPoints.Post_addBuilding(branchId), data);
};

export const GetBuildings = (branchId = 'all') => {
    return Axios.get(EndPoints.Get_getBuildings(branchId));
};

export const UpdateBuilding = (buildingId, data) => {
    return Axios.put(EndPoints.Put_updateBuilding(buildingId), data);
}

export const GetBuildingById = (buildingId) => {
    return Axios.get(EndPoints.Get_getBuildingById(buildingId));
}

export const DeleteBuilding = (buildingId) => {
    return Axios.delete(EndPoints.Delete_deleteBuilding(buildingId));
}

// * ------------------------------------------------------------------------------ Floors Apis
export const AddNewFloor = (buildingId, data) => {
    return Axios.post(EndPoints.Post_addFloor(buildingId), data);
};

export const GetFloors = (buildingId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getFloors(buildingId), { params: filters });
};

export const GetFloorById = (floorId) => {
    return Axios.get(EndPoints.Get_getFloorById(floorId));
}

export const UpdateFloor = (floorId, data) => {
    return Axios.put(EndPoints.Put_updateFloor(floorId), data);
}

export const DeleteFloor = (floorId) => {
    return Axios.delete(EndPoints.Delete_deleteFloor(floorId));
}

// * ------------------------------------------------------------------------------ Floor Layout Apis
export const GetBuildingFloorStack = (buildingId) => {
    return Axios.get(EndPoints.Get_getBuildingFloorStack(buildingId));
};

export const GetFloorLayout = (floorId, params = {}) => {
    return Axios.get(EndPoints.Get_getFloorLayout(floorId), { params });
};

export const CreateFloorLayout = (floorId, data) => {
    return Axios.post(EndPoints.Post_createFloorLayout(floorId), data);
};

export const UpdateFloorLayout = (floorId, data) => {
    return Axios.put(EndPoints.Put_updateFloorLayout(floorId), data);
};

export const PublishFloorLayout = (floorId) => {
    return Axios.post(EndPoints.Post_publishFloorLayout(floorId));
};

export const DeleteFloorLayout = (floorId) => {
    return Axios.delete(EndPoints.Delete_deleteFloorLayout(floorId));
};

export const GetFloorLayoutOccupancy = (floorId) => {
    return Axios.get(EndPoints.Get_getFloorLayoutOccupancy(floorId));
};

export const GetPlaceableEntities = (floorId) => {
    return Axios.get(EndPoints.Get_getPlaceableEntities(floorId));
};

// * ------------------------------------------------------------------------------ Offices Apis
export const AddNewOffice = (floorId, data) => {
    return Axios.post(EndPoints.Post_addOffice(floorId), data);
};

export const GetOffices = (floorId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getOffices(floorId), { params: filters });
};

export const GetOfficeById = (officeId) => {
    return Axios.get(EndPoints.Get_getOfficeById(officeId));
}

export const UpdateOffice = (officeId, data) => {
    return Axios.put(EndPoints.Put_updateOffice(officeId), data);
}

export const DeleteOffice = (officeId) => {
    return Axios.delete(EndPoints.Delete_deleteOffice(officeId));
}

// * ------------------------------------------------------------------------------ Coworking Space Apis
export const AddNewCoworkingSpace = (floorId, data) => {
    return Axios.post(EndPoints.Post_addCoWorkingSpace(floorId), data);
};

export const GetCoworkingSpaces = (floorId = 'all') => {
    return Axios.get(EndPoints.Get_getCoWorkingSpaces(floorId));
};

export const GetCoworkingSpaceById = (spaceId) => {
    return Axios.get(EndPoints.Get_getCoWorkingSpaceById(spaceId));
}

export const UpdateCoworkingSpace = (spaceId, data) => {
    return Axios.put(EndPoints.Put_updateCoworkingSpaces(spaceId), data);
}

export const DeleteCoworkingSpace = (spaceId) => {
    return Axios.delete(EndPoints.Delete_deleteCoworkingSpace(spaceId));
}

// *  ------------------------------------------------------------------------------ Seats Apis
export const AddNewSeat = (spaceId, data) => {
    return Axios.post(EndPoints.Post_addSeat(spaceId), data);
};

export const GetSeats = (spaceId = 'all', filters = {}) => {
    return Axios.get(EndPoints.Get_getSeats(spaceId), { params: filters });
};

export const GetSeatById = (seatId) => {
    return Axios.get(EndPoints.Get_getSeatById(seatId));
}

export const UpdateSeat = (seatId, data) => {
    return Axios.put(EndPoints.Put_updateSeat(seatId), data);
}

export const DeleteSeat = (seatId) => {
    return Axios.delete(EndPoints.Delete_deleteSeat(seatId));
}

export const PatchUpdateSeatStatus = (seatId, data) => {
    return Axios.patch(EndPoints.Patch_updateSeatStatus(seatId), data);
}


// * ------------------------------------------------------------------------------ Users Apis
export const AddNewUser = (data) => {
    return Axios.post(EndPoints.Post_addUser, data);
}
export const GetAllUsers = (filters) => {
    return Axios.get(EndPoints.Get_getUsers, { params: filters });
}

export const GetUserById = (userId) => {
    return Axios.get(EndPoints.Get_getUserById(userId));
}

export const DeleteUser = (userId) => {
    return Axios.delete(EndPoints.Delete_deleteUser(userId));
}

export const UpdateUser = (userId, data) => {
    return Axios.put(EndPoints.Put_updateUser(userId), data);
}

export const LoginUser = (data) => {
    return Axios.post(EndPoints.Post_loginUser, data);
}

export const UpdateUserMeetingRoomQuota = (userId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoomQuota(userId), data);
}

export const UpdateUserStatus = (userId, status) => {
    return Axios.put(EndPoints.Put_updateUserStatus(userId), { enabled: status });
}

export const SendResetPasswordEmail = (userId) => {
    return Axios.post(EndPoints.Post_sendResetPasswordEmail(userId));
}

// * ------------------------------------------------------------------------------ Booking Apis
export const AddNewBooking = (data) => {
    return Axios.post(EndPoints.Post_addBooking, data);
};

export const GetAllBookings = () => {
    return Axios.get(EndPoints.Get_getBookings);
};

export const GetBookingById = (bookingId) => {
    return Axios.get(EndPoints.Get_getBookingById(bookingId));
}

export const UpdateBooking = (bookingId, data) => {
    return Axios.put(EndPoints.Put_updateBooking(bookingId), data);
}

export const DeleteBooking = (bookingId) => {
    return Axios.delete(EndPoints.Delete_deleteBooking(bookingId));
}

export const PatchUpdateBookingStatus = (bookingId, data) => {
    return Axios.patch(EndPoints.Patch_updateBookingStatus(bookingId), data);
}

export const GetBookingsByContract = (contractId) => {
    return Axios.get(EndPoints.Get_getBookingsByContract(contractId));
}

export const GetBookingsByUser = (userId) => {
    return Axios.get(EndPoints.Get_getBookingsByUser(userId));
}

export const GetBookingsBySeat = (seatId) => {
    return Axios.get(EndPoints.Get_getBookingsBySeat(seatId));
}

// * ------------------------------------------------------------------------------ Contract Apis
export const AddNewContract = (data) => {
    return Axios.post(EndPoints.Post_addContract, data);
};

export const GetContracts = (filters = {}) => {
    return Axios.get(EndPoints.Get_getContracts, { params: filters });
};

export const GetContractByUserId = (userId) => {
    return Axios.get(EndPoints.Get_getUserContracts(userId));
}

export const UpdateContract = (contractId, data) => {
    return Axios.put(EndPoints.Put_updateContract(contractId), data);
}

export const DeleteContract = (contractId) => {
    return Axios.delete(EndPoints.Delete_deleteContract(contractId));
}

export const GetUserOwnContracts = () => {
    return Axios.get(EndPoints.Get_getUserOwnContracts);
}

export const UpdateContractWithCompletedBookings = (contractId, data) => {
    return Axios.patch(EndPoints.Patch_updateContractWithCompletedBookings(contractId), data);
}

// * ------------------------------------------------------------------------------ Meetings Room Apis
export const AddNewMeetingRoom = (floorId, data) => {
    return Axios.post(EndPoints.Post_addMeetingRoom(floorId), data);
}

export const GetMeetingRooms = (floorId = 'all') => {
    return Axios.get(EndPoints.Get_getMeetingRooms(floorId));
}

export const UpdateMeetingRoom = (meetingRoomId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoom(meetingRoomId), data);
}

export const DeleteMeetingRoom = (meetingRoomId) => {
    return Axios.delete(EndPoints.Delete_deleteMeetingRoom(meetingRoomId));
}

// * ------------------------------------------------------------------------------ Meeting Room Booking Apis
export const AddNewMeetingRoomBooking = (data) => {
    return Axios.post(EndPoints.Post_addMeetingRoomBooking, data);
}

export const GetMeetingRoomBookings = () => {
    return Axios.get(EndPoints.Get_getMeetingRoomBookings);
}

export const UpdateMeetingRoomBooking = (bookingId, data) => {
    return Axios.put(EndPoints.Put_updateMeetingRoomBooking(bookingId), data);
}

export const CancelMeetingRoomBooking = (bookingId) => {
    return Axios.put(EndPoints.Put_cancelMeetingRoomBooking(bookingId));
}

export const AddTeamMemberMeetingRoomBooking = (data) => {
    return Axios.post(EndPoints.Post_addTeamMemberMeetingRoomBooking, data);
}

// export const DeleteMeetingRoomBooking = (bookingId) => {
//     return Axios.delete(EndPoints.Delete_deleteMeetingRoomBooking(bookingId));
// }

// * ------------------------------------------------------------------------------ Stats Apis
export const GetStats = () => {
    return Axios.get(EndPoints.Get_getDashboardStats);
}

export const ForceUpdateStats = () => {
    return Axios.post(EndPoints.Post_refreshDashboardStats);
}

export const GetCustomerDashboardStats = () => {
    return Axios.get(EndPoints.Get_getCustomerDashboardStats);
}

export const GetTeamMemberDashboardStats = () => {
    return Axios.get(EndPoints.Get_getTeamMemberDashboardStats);
}

export const GetRentBreakdown = () => {
    return Axios.get(EndPoints.Get_getRentBreakdown);
}

export const GetCustomersStats = () => {
    return Axios.get(EndPoints.Get_getCustomersStats);
}

// * ------------------------------------------------------------------------------ Lead Apis
export const AddNewLead = (data) => {
    return Axios.post(EndPoints.Post_addLead, data);
}

export const GetLeads = (filters = {}) => {
    return Axios.get(EndPoints.Get_getLeads, { params: filters });
}

export const GetLeadById = (leadId) => {
    return Axios.get(EndPoints.Get_getLeadById(leadId));
}

export const UpdateLead = (leadId, data) => {
    return Axios.put(EndPoints.Put_updateLead(leadId), data);
}

export const AddEngagement = (leadId, data) => {
    return Axios.post(EndPoints.Post_addEngagement(leadId), data);
}

export const GetLeadsByRep = (repId) => {
    return Axios.get(EndPoints.Get_getLeadsByRep(repId));
}

export const DeleteLead = (leadId) => {
    return Axios.delete(EndPoints.Delete_deleteLead(leadId));
}

export const AddTeamMemberByAdmin = (data) => {
    return Axios.post(EndPoints.Post_addTeamMemberByAdmin, data);
}

// * ------------------------------------------------------------------------------ User Group Apis
export const CreateUGroup = (data) => {
    return Axios.post(EndPoints.Post_createUGroup, data);
}

export const GetUGroups = () => {
    return Axios.get(EndPoints.Get_getUGroups);
}

export const GetUGroupById = (groupId) => {
    return Axios.get(EndPoints.Get_getUGroupById(groupId));
}

export const UpdateUGroup = (groupId, data) => {
    return Axios.put(EndPoints.Put_updateUGroup(groupId), data);
}

export const DeleteUGroup = (groupId) => {
    return Axios.delete(EndPoints.Delete_deleteUGroup(groupId));
}

export const AddUserToUGroup = (groupId, data) => {
    return Axios.post(EndPoints.Post_addUserToUGroup(groupId), data);
}

export const RemoveUserFromUGroup = (groupId, userId) => {
    return Axios.delete(EndPoints.Delete_removeUserFromUGroup(groupId, userId));
}

export const GetUGroupByUserId = (userId) => {
    return Axios.get(EndPoints.Get_getUGroupByUserId(userId));
}

export const GetUGroupByUrl = (url) => {
    return Axios.post(EndPoints.Post_getUGroupByUrl, url);
}

export const GetUGroupByFunction = (func) => {
    return Axios.post(EndPoints.Post_getUGroupByFunction, func);
}

// * ------------------------------------------------------------------------------ Customer Support Apis
export const CreateTicket = (data) => {
    return Axios.post(EndPoints.Post_createTicket, data);
}

export const GetTickets = () => {
    return Axios.get(EndPoints.Get_getTickets);
}

export const GetTicketById = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketById(ticketId));
}

export const AddInteraction = (ticketId, data) => {
    return Axios.post(EndPoints.Post_addInteraction(ticketId), data);
}

export const AcknowledgeResolution = (ticketId) => {
    return Axios.post(EndPoints.Post_acknowledgeResolution(ticketId));
}

export const SubmitFeedback = (ticketId, data) => {
    return Axios.post(EndPoints.Post_submitFeedback(ticketId), data);
}

// * ------------------------------------------------------------------------------ Support Apis
export const GetSupportTickets = () => {
    return Axios.get(EndPoints.Get_getTickets);
}

export const GetSupportTicketById = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketById(ticketId));
}

export const AddSupportTicket = (data) => {
    return Axios.post(EndPoints.Post_createTicket, data);
}

export const UpdateSupportTicket = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicket(ticketId), data);
}

export const DeleteSupportTicket = (ticketId) => {
    return Axios.delete(EndPoints.Delete_deleteTicket(ticketId));
}

export const GetSupportTicketInteractions = (ticketId) => {
    return Axios.get(EndPoints.Get_getInteractions(ticketId));
}

export const AddSupportTicketInteraction = (ticketId, data) => {
    return Axios.post(EndPoints.Post_addInteraction(ticketId), data);
}

export const AcknowledgeSupportTicketResolution = (ticketId, data) => {
    return Axios.post(EndPoints.Post_acknowledgeResolution(ticketId), data);
}

export const SubmitSupportTicketFeedback = (ticketId, data) => {
    return Axios.post(EndPoints.Post_submitFeedback(ticketId), data);
}

export const GetAllTickets = (filters = {}) => {
    return Axios.get(EndPoints.Get_getAllTickets, { params: filters });
}

export const GetTicketDetails = (ticketId) => {
    return Axios.get(EndPoints.Get_getTicketDetails(ticketId));
}

export const UpdateTicketStatus = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketStatus(ticketId), data);
}

export const AssignTicket = (ticketId, data) => {
    return Axios.put(EndPoints.Put_assignTicket(ticketId), data);
}

export const CreateTicketByAdmin = (data) => {
    return Axios.post(EndPoints.Post_createTicketByAdmin, data);
}

export const UpdateTicketDueDate = (ticketId, data) => {
    return Axios.put(EndPoints.Put_updateTicketDueDate(ticketId), data);
}

// * ------------------------------------------------------------------------------ Day Pass Apis
export const CreateDayPass = (data) => {
    return Axios.post(EndPoints.Post_createDayPass, data);
}

export const GetDayPasses = () => {
    return Axios.get(EndPoints.Get_getDayPasses);
}

export const GetDayPassById = (dayPassId) => {
    return Axios.get(EndPoints.Get_getDayPassById(dayPassId));
}

export const ApproveDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_approveDayPass(dayPassId), data);
}

export const CheckInDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_checkInDayPass(dayPassId), data);
}

export const CheckOutDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_checkOutDayPass(dayPassId), data);
}

export const UpdateDayPassPaymentStatus = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_updateDayPassPaymentStatus(dayPassId), data);
}

export const GetDayPassesByDate = (date) => {
    return Axios.get(EndPoints.Get_getDayPassesByDate(date));
}

export const GetDayPassesByCustomerEmail = (email) => {
    return Axios.get(EndPoints.Get_getDayPassesByCustomerEmail(email));
}

export const GetDayPassesByCustomerId = (customerId) => {
    return Axios.get(EndPoints.Get_getDayPassesByCustomerId(customerId));
}

export const CancelDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_cancelDayPass(dayPassId), data);
}

export const ExtendDayPass = (dayPassId, data) => {
    return Axios.patch(EndPoints.Patch_extendDayPass(dayPassId), data);
}

// * ------------------------------------------------------------------------------ Notification Apis
export const GetUserNotifications = () => {
    return Axios.get(EndPoints.Get_getUserNotifications);
}

export const MarkNotificationRead = (notificationId, data) => {
    return Axios.patch(EndPoints.Patch_markNotificationRead(notificationId), data);
}